import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import {
  getFormatFromType,
  useCommonWidgetHandlers,
} from './use-common-widget-handlers';
import ImageWidget from '../../../editor/features/build/requestModels/widgets/ImageWidget';
import { uploadImage } from '@mm/state/actions/uploadActions';
import WidgetModel from '@mm/state/model/WidgetModel';
import { StoreState } from '@mm/state/store-interfaces';

export const useImageWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const dispatch: Dispatch<StoreState> = useDispatch();

  const addImageToWidget = async (widget: WidgetModel, image?: File | Blob) => {
    if (image) {
      const id = await dispatch(
        uploadImage({
          content: image,
          extension: getFormatFromType(image.type),
        }),
      );

      await commonWidgetHandlers.updateAssetId(widget, id);
    }
  };

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = ImageWidget.make(dialogueId, sortOrder);
    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    addImageToWidget,
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
